import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=319b1a29&scoped=true"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"
import style0 from "./Denied.vue?vue&type=style&index=0&id=319b1a29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b1a29",
  null
  
)

export default component.exports